export default {
  errors: {
    cannotBeBlank: "Questo campo non può essere vuoto",
    required: "Questo campo è richiesto",
    somethingWentWrong: "Qualcosa è andato storto!!!",
  },
  logs: {
    time: "Tempo",
    username: "Nome utente",
    role: "Role",
    terminalID: "ID terminale",
    moduleAccessed: "Modulo di accesso",
    typeOfAccess: "Tipo di accesso",
    activityLogDetails: "Dettagli del registro di attività",
    userId: "ID utente",
    lastLogin: "Ultimo accesso",
    geoAccPoint: "Punto di accesso geografico",
    ipAdd: "Indirizzo IP",
    filesAccessed: "File accessibili",
    funAccessed: "Funzione accessibile",
    webUrl: "URL pagina web",
    unsuccAtmp: "Unsuccessful Login attempt",
    view: "Vista",
    membershipType: "Tipo di iscrizione",
  },
  validation: {
    exporterRequired: "Il campo Esportatore è obbligatorio",
    importerRequired: "Il campo Importatore è obbligatorio",
    portOfOriginRequired: "Il campo Porto di Origine è obbligatorio",
    containerSizeNumber:
      "Il campo Dimensione del Contenitore deve essere un numero",
    containerCapacityNumber:
      "Il campo Capacità del Contenitore deve essere un numero",
  },
};
